import * as React from "react"

import { cn } from "@/lib/utils"
// We'll reuse the Button styles or extend them, but for a standalone premium feeling,
// we might want to build it on top of the base button or just copy the relevant parts.
// Let's import the Button component to compose or just style a new one.
// Actually, the requirement says "The button should wrap the text and have an overflow-hidden..."
// It's cleaner to make it a wrapper around the existing Button or a compatible component.
import { Button, ButtonProps } from "@/components/ui/button"

// "Obsidian Glow" Pattern
// Base Color: Deep Indigo/Violet (Indigo-600 to Purple-600)
// Shimmer: White-light streak
// Glow: Drop-shadow matching primary color in dark mode

const PremiumButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({ className, children, ...props }, ref) => {
        return (
            <Button
                ref={ref}
                className={cn(
                    "relative overflow-hidden transition-all duration-300",
                    "bg-gradient-to-r from-indigo-600 via-purple-600 to-indigo-600",
                    "text-white font-bold tracking-wide border-0",
                    "hover:scale-105 active:scale-95",
                    "shadow-md dark:shadow-[0_0_15px_rgba(139,92,246,0.5)]", // Obsidian Glow
                    "background-size-200 animate-bg-shift", // Optional: subtle background movement if we had that animation, but let's stick to the prompt's shimmer for now
                    className
                )}
                {...props}
            >
                {/* Shimmer Effect */}
                <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/25 to-transparent -translate-x-full animate-shimmer" />

                {/* Content */}
                <span className="relative z-10 flex items-center gap-2">
                    {children}
                </span>
            </Button>
        )
    }
)
PremiumButton.displayName = "PremiumButton"

export { PremiumButton }
